/**
 * Similar to `mapGetters` in Vuex, this generates feature flag aware computed
 * properties on any component. A default state can be optionally passed for
 * each flag, otherwise it is assumed to be on by default. Since feature flags
 * are stored on an Instance, the Vuex module must be installed. Otherwise, the
 * default value for the feature flag will be returned.
 *
 * @param {Array|Object} flags
 * @return {Object} - Computed properties for each of the feature flags.
 */
export function mapFlags (flags) {
  if (Array.isArray(flags)) {
    flags = flags.reduce((result, flag) => {
      result[flag] = true
      return result
    }, {})
  }

  return Object.entries(flags).reduce((result, [flag, value]) => {
    if (typeof value === 'boolean') {
      value = { flag, default: value }
    }

    result[flag] = function mappedFlag () {
      if (!this.$store?.state.instance) return value.default ?? true
      return this.$store.getters['instance/feature'](value.flag, value.default)
    }

    return result
  }, {})
}
